import type { MouseEventHandler } from 'react'
import FacebookIcon from './facebook-icon'

interface SocialShareProps {
  title: string
  author: string
}

const SocialShare = ({ title, author }: SocialShareProps) => {
  const onClickFacebookIcon: MouseEventHandler = (e) => {
    e.preventDefault()
    window.FB.ui({
      method: 'share',
      mobile_iframe: true,
      href: window.location.href,
      quote: `Recommend on "${title}" written by @${author}`,
    })
  }

  return (
    <div className="text-right h-full">
      <FacebookIcon onClick={onClickFacebookIcon} />
    </div>
  )
}

export default SocialShare
